import { type RouteRecordRaw } from 'vue-router';

export enum MODULE_ROUTE {
  password = 'SuccessPassword',
  download = 'SuccessDownload',
  login = 'SuccessLogin',
  email = 'SuccessEmail',
}

export const routes: RouteRecordRaw[] = [
  {
    path: '/:lang?/success/',
    component: () => import('@/modules/thank-purchase/layout/LayoutPage.vue'),
    redirect: {
      name: MODULE_ROUTE.password,
    },
    children: [
      {
        path: 'password/:productId',
        name: MODULE_ROUTE.password,
        component: () =>
          import('@/modules/thank-purchase/pages/password/PagePassword.vue'),
        meta: {
          i18nAlias: 'thank-purchase',
        },
      },
      {
        path: 'download/:productId',
        name: MODULE_ROUTE.download,
        component: () =>
          import('@/modules/thank-purchase/pages/download/PageDownload.vue'),
        meta: {
          i18nAlias: 'thank-purchase',
        },
      },
      {
        path: 'login/:productId',
        name: MODULE_ROUTE.login,
        component: () =>
          import('@/modules/thank-purchase/pages/login/PageLogin.vue'),
        meta: {
          i18nAlias: 'thank-purchase',
        },
      },
    ],
  },
  {
    path: '/:lang?/success/',
    component: () =>
      import('@/modules/thank-purchase/layout/LayoutEmailPage.vue'),
    children: [
      {
        path: 'email/:productId',
        name: MODULE_ROUTE.email,
        component: () =>
          import('@/modules/thank-purchase/pages/email/PageEmail.vue'),
        meta: {
          i18nAlias: 'thank-purchase',
        },
      },
    ],
  },
];
